import React from "react";

/**
 * Reusable Error Message Component
 */
const ErrorMessage = ({ error, onRetry, showRetry = true, className = "" }) => {
  if (!error) return null;

  return (
    <div
      className={`flex items-center justify-between p-4 my-4 bg-red-50 border border-red-200 rounded-md text-red-800 ${className}`}
    >
      <div className="flex items-center gap-2">
        <span className="text-xl">⚠️</span>
        <div className="flex-1">
          <strong>Error:</strong> {error}
        </div>
      </div>
      {showRetry && onRetry && (
        <button
          onClick={onRetry}
          className="ml-4 px-4 py-2 bg-orange-500 text-white rounded-md hover:bg-orange-600 transition-colors duration-200 text-sm font-medium"
        >
          Retry
        </button>
      )}
    </div>
  );
};

export default ErrorMessage;
